import { atom } from 'recoil';
import * as K from 'common/constants';

export const preventLogInspectorFromClosingState = atom<boolean>({
  key: K.RECOIL_ATOM_KEY.PREVENT_LOG_INSPECTOR_FROM_CLOSING,
  default: false,
});
